// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

// each table row with the class `expandable-tr`, which is followed by a table
// row with the class `expandable-tr--content`, will toggle the visibility of
// the content-row when clicked.
up.compiler('.expandable-tr', function(element) {
  const content = element.nextElementSibling
  if (content.classList.contains('.expandable-tr--content')) {
    throw new Error('an .expandable-tr element has to be followed by .expandable-tr--content')
  }
  const caretElement = element.querySelector('.expandable-tr--caret')

  const toggleArrows = function() {
    caretElement.classList.toggle('fa-caret-down')
    caretElement.classList.toggle('fa-caret-right')
  }

  element.addEventListener('click', function() {
    const revealContentNow = !up.element.isVisible(content)
    const animation = revealContentNow ? 'fade-in' : 'fade-out'
    if (revealContentNow) {
      // has to be shown before the animation
      up.element.show(content)
    }
    up.animate(content, animation, {
      duration: 1000,
      easing: 'ease',
    }).then(() => {
      if (!revealContentNow) {
        // has to be hidden after the animation
        up.element.hide(content)
      }
    })

    toggleArrows()
  })
})
